export default __webpack_public_path__ + "static/media/phone.ce327d39.svg";